<template>
    <div id="app">
        <ejs-tab id="element" ref='productsTab' :selected="onTabProdSpecSelected">
            <e-tabitems>
                <e-tabitem :header='headerText1' :content='productTemplate'></e-tabitem>
                <e-tabitem :header='headerText2' :content='tradePeriodTemplate'></e-tabitem>
                <e-tabitem :header='headerText3' :content='spotEchangeTemplate'></e-tabitem>
                <e-tabitem :header='headerText12' :content='spotConfigurationTemplate'></e-tabitem>
                <e-tabitem :header='headerText13' :content='spotConfigurationLogsTemplate'></e-tabitem>
                <e-tabitem :header='headerText4' :content='futureExhangeTemplate'></e-tabitem>
                <e-tabitem :header='headerText5' :content='ricTemplate'></e-tabitem>
                <e-tabitem :header='headerText9' :content='ricLogsTemplate'></e-tabitem>
                <e-tabitem :header='headerText14' :content='derivedCurveTemplate'></e-tabitem>
                <e-tabitem :header='headerText15' :content='derivedCurveLogTemplate'></e-tabitem>
                <!--<e-tabitem :header='headerText8' :content='ricOtherTemplate'></e-tabitem>
                <e-tabitem :header='headerText10' :content='ricOtherLogsTemplate'></e-tabitem>-->
                <e-tabitem :header='headerText6' :content='ccTemplate'></e-tabitem>
                <e-tabitem :header='headerText11' :content='ccLogsTemplate'></e-tabitem>
                <e-tabitem :header='headerText7' :content='shapeTemplate'></e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</template>
<script>
    import Vue from 'vue';
    import { TabPlugin } from '@syncfusion/ej2-vue-navigations';
    import ccForm from '@/views/administration/product/CurrencyConversion.vue';
    import futureExchangeForm from '@/views/administration/product/FutureExchange.vue';
    import marketShapeForm from '@/views/administration/product/MarketShape.vue';
    import productForm from '@/views/administration/product/Product.vue';
    import ricForm from '@/views/administration/product/Ric.vue';
    import ricOtherForm from '@/views/administration/product/RicOther.vue';
    import spotExchangeForm from '@/views/administration/product/SpotExchange.vue';
    import spotConfigurationForm from '@/views/administration/product/SpotConfiguration.vue';
    import spotConfigurationLogsForm from '@/views/administration/product/SpotConfigurationLogs.vue';
    import tradePeriodForm from '@/views/administration/product/TradePeriod.vue';
    import { DatePickerComponent, CalendarComponent, DatePickerPlugin, CalendarPlugin } from '@syncfusion/ej2-vue-calendars';
    import ricLogs from '@/views/administration/product/RicLogs.vue';
    import ricOtherLogs from '@/views/administration/product/RicOtherLogs.vue';
    import ccLogs from '@/views/administration/product/CurrencyConversionLogs.vue';
    import derivedCurveForm from '@/views/administration/product/DerivedCurve.vue';
    import derivedCurveLogs from '@/views/administration/product/DerivedCurveLogs.vue';

    Vue.use(TabPlugin);
    Vue.use(TabPlugin);
    Vue.component(DatePickerPlugin.name, DatePickerComponent);
    Vue.component(CalendarPlugin.name, CalendarComponent);

    export default {
        name: 'app',
        data: function () {
            return {
                headerText1: { text: 'Products' },
                headerText2: { text: 'Tradeable Periods' },
                headerText3: { text: 'Spot Exchanges' },
                headerText12: { text: 'Spot Configuration' },
                headerText13: { text: 'Spot Configuration Logs' },
                headerText4: { text: 'Future Exchanges' },
                headerText5: { text: 'Energy Instruments' },
                //headerText8: { text: 'Other Instruments' },
                headerText6: { text: 'FX Instruments' },
                headerText7: { text: 'Shapes' },
                headerText9: { text: 'Energy Instruments Logs' },
                //headerText10: { text: 'Other Instruments Logs' },
                headerText11: { text: 'FX Instruments Logs' },
                headerText14: { text: 'Derived Curves' },
                headerText15: { text: 'Derived Curves Logs' },
                propsData: null,
                productTemplate: function () {
                    return {
                        template: {
                            extends: productForm
                        }
                    }
                },
                tradePeriodTemplate: function () {
                    return {
                        template: {
                            extends: tradePeriodForm
                        }
                    }
                },
                spotEchangeTemplate: function () {
                    return {
                        template: {
                            extends: spotExchangeForm
                        }
                    }
                },
                spotConfigurationTemplate: function () {
                    return {
                        template: {
                            extends: spotConfigurationForm
                        }
                    }
                },
                spotConfigurationLogsTemplate: function () {
                    return {
                        template: {
                            extends: spotConfigurationLogsForm
                        }
                    }
                },
                futureExhangeTemplate: function () {
                    return {
                        template: {
                            extends: futureExchangeForm
                        }
                    }
                },
                ricTemplate: function () {
                    return {
                        template: {
                            extends: ricForm
                        }
                    }
                },
                ricLogsTemplate: function () {
                    return {
                        template: {
                            extends: ricLogs
                        }
                    }
                },
                ricOtherTemplate: function () {
                    return {
                        template: {
                            extends: ricOtherForm
                        }
                    }
                },
                ricOtherLogsTemplate: function () {
                    return {
                        template: {
                            extends: ricOtherLogs
                        }
                    }
                },
                derivedCurveTemplate: function () {
                    return {
                        template: {
                            extends: derivedCurveForm
                        }
                    }
                },
                derivedCurveLogTemplate: function () {
                    return {
                        template: {
                            extends: derivedCurveLogs
                        }
                    }
                },
                ccTemplate: function () {
                    return {
                        template: {
                            extends: ccForm
                        }
                    }
                },
                ccLogsTemplate: function () {
                    return {
                        template: {
                            extends: ccLogs
                        }
                    }
                },
                shapeTemplate: function () {
                    return {
                        template: {
                            extends: marketShapeForm
                        }
                    }
                }
                
            }
        },
        methods: {
            onTabProdSpecSelected(args) {
                if (args.selectedIndex == 4 || args.selectedIndex == 7) {
                    this.$refs.productsTab.ej2Instances.vueInstance.refresh();
                }
            }
        },
        mounted: function () {
            if (!this.$store.state.permissions["Permissions.Product.View"]) {
                this.$refs.productsTab.hideTab(0);
            }
            if (!this.$store.state.permissions["Permissions.TradePeriod.View"]) {
                this.$refs.productsTab.hideTab(1);
            }
            if (!this.$store.state.permissions["Permissions.SpotExchanges.View"]) {
                this.$refs.productsTab.hideTab(2);
            }
            if (!this.$store.state.permissions["Permissions.SpotConfig.View"]) {
                this.$refs.productsTab.hideTab(3);
                this.$refs.productsTab.hideTab(4);
            }
            if (!this.$store.state.permissions["Permissions.FutureExchanges.View"]) {
                this.$refs.productsTab.hideTab(5);
            }
            if (!this.$store.state.permissions["Permissions.Ric.View"]) {
                this.$refs.productsTab.hideTab(6);
                this.$refs.productsTab.hideTab(7);
            }
            if (!this.$store.state.permissions["Permissions.RicOtherInstruments.View"]) {
                this.$refs.productsTab.hideTab(8);
                this.$refs.productsTab.hideTab(9);
            }
            if (!this.$store.state.permissions["Permissions.CurrencyConversion.View"]) {
                this.$refs.productsTab.hideTab(11);
                this.$refs.productsTab.hideTab(12);
            }
            if (!this.$store.state.permissions["Permissions.MarketShape.View"]) {
                this.$refs.productsTab.hideTab(13);
            }
            if (!this.$store.state.permissions["Permissions.DerivedCurve.View"]) {
                this.$refs.productsTab.hideTab(10);
                this.$refs.productsTab.hideTab(11);
            }       
        },
    }
</script>

<style>
    .required-input.e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
        font-weight: bold;
    }
</style>